import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Editbox from '../../Part_Sample/Editbox';

export default class Owner_Settings extends Component {
	constructor(props) {
		super(props);
		let owner_info = this.props.param.owner_info;
		this.owner_info = owner_info;
		this.state = {
			owner_name: owner_info.name == null ? '' : owner_info.name,
			address: owner_info.addr1 == null ? '' : owner_info.addr1,
			address_2: owner_info.addr2 == null ? '' : owner_info.addr2,
			postal_code: owner_info.postalcode == null ? '' : owner_info.postalcode,
			contact: owner_info.contact == null ? '' : owner_info.contact,
			tel: owner_info.tel == null ? '' : owner_info.tel,
			email: owner_info.email == null ? '' : owner_info.email
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('Billing_Main');
	}

	handleChangeOwnerName = (owner_name) => {
		this.setState({ owner_name: owner_name })
	}

	handleChangeAddress = (address) => {
		this.setState({ address: address })
	}

	handleChangeAddress2 = (address_2) => {
		this.setState({ address_2: address_2 })
	}

	handleChangePostalCode = (postal_code) => {
		this.setState({ postal_code: postal_code })
	}

	handleChangeContact = (contact) => {
		this.setState({ contact: contact })
	}

	handleChangeTel = (tel) => {
		this.setState({ tel: tel })
	}

	handleChangeEmail = (email) => {
		this.setState({ email: email })
	}

	//Save information
	handleRegister = () => {
		let owner_info = this.owner_info;
		owner_info.name = this.state.owner_name;
		owner_info.addr1 = this.state.address;
		owner_info.addr2 = this.state.address_2;
		owner_info.postalcode = this.state.postal_code;
		owner_info.contact = this.state.owner_name;
		owner_info.tel = this.state.tel;
		owner_info.email = this.state.email;
		this.props.receiver.saveOwnerInfo(owner_info);
	}

	//Response from controller after saving owner information
	rcvSaveOwnerInfo = (response) => {
		if (response != null && response.result == 'OK') this.handlePrevious();
	}

	render() {

		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('owner_settings')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					<div style={{ marginTop: 20, height: this.props.height - 120, overflow: 'auto', paddingBottom: window.innerHeight < window.innerWidth ? 100 : 0 }}>

						<div style={{ textAlign: 'center' }}>
							<Editbox id='owner_name' style={{ width: this.props.width - 40, margin: 'auto' }} placeholder={this.props.receiver.getString('owner')} inputType='text' onChange={(event) => this.handleChangeOwnerName(event.target.value)} value={this.state.owner_name} />
						</div>

						<div style={{ textAlign: 'center' }}>
							<Editbox id='address' style={{ width: this.props.width - 40, margin: 'auto' }} placeholder={this.props.receiver.getString('address')} inputType='text' onChange={(event) => this.handleChangeAddress(event.target.value)} value={this.state.address} />
						</div>

						<div style={{ textAlign: 'center' }}>
							<Editbox id='address_2' style={{ width: this.props.width - 40, margin: 'auto' }} placeholder={this.props.receiver.getString('address') + " 2"} inputType='text' onChange={(event) => this.handleChangeAddress2(event.target.value)} value={this.state.address_2} />
						</div>

						<div style={{ textAlign: 'center' }}>
							<Editbox id='postal_code' style={{ width: this.props.width - 40, margin: 'auto' }} placeholder={this.props.receiver.getString('postal_code')} inputType='text' onChange={(event) => this.handleChangePostalCode(event.target.value)} value={this.state.postal_code} />
						</div>

						<div style={{ textAlign: 'center' }}>
							<Editbox id='contact' style={{ width: this.props.width - 40, margin: 'auto' }} placeholder={this.props.receiver.getString('contact')} inputType='text' onChange={(event) => this.handleChangeContact(event.target.value)} value={this.state.contact} />
						</div>

						<div style={{ textAlign: 'center' }}>
							<Editbox id='tel' style={{ width: this.props.width - 40, margin: 'auto' }} placeholder={this.props.receiver.getString('tel')} inputType='text' onChange={(event) => this.handleChangeTel(event.target.value)} value={this.state.tel} />
						</div>

						<div style={{ textAlign: 'center' }}>
							<Editbox id='email' style={{ width: this.props.width - 40, margin: 'auto' }} placeholder={this.props.receiver.getString('email')} inputType='text' onChange={(event) => this.handleChangeEmail(event.target.value)} value={this.state.email} />
						</div>

					</div>

				</div>
			</div>
		)
	}
}